import { StyleSheet } from "@react-pdf/renderer";
import theme from "../../../../../css/WhiteLabelledDocuments/theme";
import { Font } from "@react-pdf/renderer";
import OpenSansBold from "../../../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";
import RobotoBold from "../../../../../assets/fonts/Roboto/Roboto-Bold.ttf";
import RobotoRegular from "../../../../../assets/fonts/Roboto/Roboto-Regular.ttf";
import RobotoSemiBold from "../../../../../assets/fonts/Roboto/Roboto-SemiBold.ttf";
import RobotoItalic from "../../../../../assets/fonts/Roboto/Roboto-Italic.ttf";
import RalewayRegular from "../../../../../assets/fonts/Raleway/Raleway-Regular.ttf";
import RalewayBold from "../../../../../assets/fonts/Raleway/Raleway-Bold.ttf";

Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansRegular, fontWeight: "normal" },
  ],
});

Font.register({
  family: "Roboto",
  fonts: [
    { src: RobotoBold, fontWeight: "bold" },
    { src: RobotoRegular, fontWeight: "normal" },
    { src: RobotoSemiBold, fontWeight: "500" },
    { src: RobotoItalic, fontStyle: "italic" },
  ],
});

//  Helper to convert hex to RGB
const hexToRgb = (hex) => {
  //   const cleanHex = hex.replace("#", "");
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

// Helper to calculate brightness
const getTextColor = (hex) => {
  const { r, g, b } = hexToRgb(hex);
  // relative luminance formula
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 186 ? "#000000" : "#ffffff"; // threshold
};

const blendWithWhite10 = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(hex);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

const blendWithWhite = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(hex);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

const TaxGuideStyles = (primaryColor) =>
  // const textColor = getTextColor(primaryColor);
  // const highlightBg = blendWithWhite(primaryColor, 0.1);
  // const headerfooterBg = blendWithWhite10(primaryColor, 0.3);

  StyleSheet.create({
    page: {
      padding: 10,
      gap: 10,
      marginTop: 10,
      marginBottom: 10,
    },
    pageLeft: {
      flex: 1,
      flexDirection: "column",
      padding: 10,
      gap: 20,
    },
    pageCoverRight: {
      flex: 1,
      // backgroundColor: blendWithWhite10(primaryColor, 0.05),
      backgroundColor: "white",
      width: "100%",
      height: "100%",
      padding: 10,
      border: `5px solid ${blendWithWhite(primaryColor, 1)}`,
    },
    pageRight: {
      flex: 1,
      // backgroundColor: blendWithWhite10(primaryColor, 0.05),
      width: "100%",
      height: "100%",
      padding: 10,
      gap: 20,
    },
    graphicWrapper: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    graphicBox: {
      backgroundColor: blendWithWhite10(primaryColor, 0.7),
      position: "absolute",
      bottom: "0%",
      left: "-22%",
      width: "130%",
      height: "40%",
      transform: "rotate(17deg)",
    },
    graphicBox1: {
      backgroundColor: `#${primaryColor}`,
      position: "absolute",
      bottom: "-45%",
      left: "-25%",
      width: "150%",
      height: "80%",
      transform: "rotate(15deg)",
    },
    graphicBox2: {
      backgroundColor: blendWithWhite10(primaryColor, 0.6),
      position: "absolute",
      bottom: "73%",
      right: "-20%",
      width: "200%",
      height: "2%",
      transform: "rotate(35deg)",
    },
    graphicBox3: {
      backgroundColor: blendWithWhite10(primaryColor, 0.2),
      position: "absolute",
      bottom: "75.3%",
      right: "-20%",
      width: "200%",
      height: "2%",
      transform: "rotate(35deg)",
    },
    graphicBox4: {
      position: "absolute",
      bottom: "8%",
      right: "28%",
      width: 45,
      height: 45,
      transform: "rotate(45deg)",
      backgroundColor: `#${primaryColor}`,
    },
    graphicBox5: {
      backgroundColor: blendWithWhite(primaryColor, 0.5),
      position: "absolute",
      bottom: "9%",
      right: "25%",
      width: 30,
      height: 30,
      transform: "rotate(45deg)",
    },
    graphicBox6: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.3),
      position: "absolute",
      bottom: "12%",
      right: "42%",
      width: 25,
      height: 25,
      border: `2px solid ${blendWithWhite(primaryColor, 0.8)}`,
      transform: "rotate(45deg)",
    },
    graphicBox7: {
      // backgroundColor: blendWithWhite10(primaryColor, 0.4),
      border: `3px solid ${blendWithWhite(primaryColor, 0.6)}`,
      position: "absolute",
      bottom: "5%",
      right: "4%",
      width: 60,
      height: 60,
      transform: "rotate(45deg)",
    },
    graphicBox8: {
      backgroundColor: blendWithWhite(primaryColor, 0.5),
      position: "absolute",
      bottom: "10%",
      right: "50%",
      width: 15,
      height: 15,
      transform: "rotate(45deg)",
    },
    header: {
      fontFamily: "Open Sans",
      fontSize: 14,
      textAlign: "center",
      fontWeight: "bold",
      letterSpacing: 1,
      color: `#${primaryColor}`,
      alignItems: "center",
      // flexGrow: 1,
    },
    pageHeader: {
      position: "absolute",
      top: 0,
      left: 20,
      right: 20,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      // backgroundColor: `#${primaryColor}`,
    },
    pageWithChrome: {
      paddingLeft: 30,
      paddingRight: 30,
      paddingTop: 40,
      paddingBottom: 50,
    },
    pageHeaderText: {
      fontSize: 8,
      color: blendWithWhite(primaryColor, 0.6),
    },
    pageFooterText: {
      fontSize: 6,
      textAlign: "center",
      color: blendWithWhite(primaryColor, 0.6),
    },
    footer: {
      position: "absolute",
      bottom: 20,
      left: 30,
      right: 30,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      fontSize: 10,
    },
    disclaimerTextContainer: {
      marginTop: 380,
      position: "fixed",
      paddingLeft: 10,
      paddingRight: 10,
      width: "100%",
      color: getTextColor(primaryColor),
      // border: `1px solid ${blendWithWhite(primaryColor, 0.6)}`,
      // backgroundColor: highlightBg,
    },

    disclaimerText: {
      color: getTextColor(primaryColor),
      textAlign: "left",
    },
    footerText: {
      fontSize: 10,
      color: blendWithWhite(primaryColor, 0.6),
    },
    pageNumber: {
      fontSize: 10,
      color: blendWithWhite(primaryColor, 0.6),
      textAlign: "right",
    },
    row: {
      flexDirection: "row", // Align items horizontally
      justifyContent: "space-between", // Push content to edges
      alignItems: "center", // Align items vertically in the center
      alignContent: "center",
    },
    column: {
      flexDirection: "column", // Align items horizontally
      justifyContent: "center", // Push content to edges
      alignItems: "center", // Align items vertically in the center
      alignContent: "center",
      marginBottom: 10,
    },

    iconImages: {
      display: "flex",
      flex: 1,
    },
    centeredContent: {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      textAlign: "center",
      gap: 5,
      height: "100%",
      // backgroundColor: blendWithWhite10(primaryColor, 0.05),
      // marginTop: 450,
    },
    content: {
      marginTop: 5,
      marginBottom: 5,
      textAlign: "justify",
      fontFamily: "Open Sans",
      fontSize: 10,
      lineHeight: 1.5,
      wrap: false,
    },
    contentSmall: {
      // marginBottom: 5,
      textAlign: "justify",
      fontSize: 8,
      fontFamily: "Open Sans",
      // lineHeight: 1.5,
      wrap: false,
    },
    contentSmallItalic: {
      marginBottom: 5,
      textAlign: "justify",
      fontSize: 8,
      fontFamily: "Roboto",
      fontStyle: "italic",
      // lineHeight: 1.5,
      wrap: false,
    },
    contentBold: {
      //   marginBottom: 5,
      textAlign: "justify",
      fontSize: 10,
      // lineHeight: 1.5,
      fontWeight: "bold",
      wrap: false,
    },
    contentSmallBold: {
      //   marginBottom: 5,
      textAlign: "left",
      fontSize: 8,
      // lineHeight: 1.5,
      fontWeight: "bold",
      wrap: false,
    },
    contentBoldRed: {
      //   marginBottom: 5,
      textAlign: "justify",
      fontSize: 10,
      lineHeight: 1.5,
      fontWeight: "bold",
      wrap: false,
      color: "red",
    },
    subcontent: {
      fontFamily: "Open Sans",
      fontWeight: "bold",
      textAlign: "justify",
      fontSize: 10,
      lineHeight: 1.5,
      color: `#${primaryColor}`,
    },
    subheading: {
      fontFamily: "Open Sans",
      fontSize: 10,
      letterSpacing: 1,
      // marginTop: 5,
      fontWeight: "bold",
      color: `#${primaryColor}`,
      lineHeight: 1.5,
    },
    text: { marginBottom: 5, color: theme.colors.Brand1PenBlue },
    image: {
      maxWidth: 275,
      maxHeight: 215,
    },
    verticleSizedBox: {
      height: 10,
    },
    verticleDivider: {
      height: 520,
      width: 1,
      marginRight: 7,
      marginLeft: 7,
      backgroundColor: blendWithWhite10(primaryColor, 0.1),
    },
    container: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "100%",
      gap: 3,
      padding: 10,
      backgroundColor: blendWithWhite10(primaryColor, 0.05),
      border: `1px solid ${blendWithWhite(primaryColor, 1)}`,
      // border: `1px solid ${blendWithWhite(primaryColor, 0.3)}`,
      borderRadius: 5,
    },
    containerRow: {
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      width: "100%",
      gap: 10,
    },

    smallSizedBox: {
      height: 5,
    },
    containerColumn: {
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-end",
      gap: 0,
    },
  });

export default TaxGuideStyles;
